import axios, { AxiosResponse } from 'axios'

import { env } from '@js/utils/env'
import gql from '@js/api/utils/gql'
import getStoreName from '@js/api/utils/getStoreName'
import getBearerToken from '@js/api/utils/getBearerToken'

interface PlaceOrderPayload {
  sku: string
  cartId: string
  quantity: number
  courseOption: string
  registrationId: number
  paying_by: string
}

interface PlaceOrderResponse {
  data: {
    wceiPlaceOrder: {
      order_id: number
    } | null
  }
  errors?: [{ message: string }]
}

export const placeOrderMutation = gql`
  mutation(
    $cartId: String!,
    $courseOption: String!,
    $quantity: Int!,
    $registrationId: Int!,
    $sku: String!,
    $paying_by: String! 
  ) {
    wceiPlaceOrder(
      input: {
        cart_id: $cartId,
        course_option: $courseOption,
        qty: $quantity,
        registration_id: $registrationId,
        sku: $sku,
        paying_by: $paying_by
      }
    ) {
      order_id
    }
  }
`

/**
 * @throws {string}
 *
 * Will throw one error message; Magento only returns one at a time, rather than an array of all errors.
 */
export const placeOrder = async (payload: PlaceOrderPayload): Promise<number | null> => {
  const bearerToken = getBearerToken()

  const { data }: AxiosResponse<PlaceOrderResponse> = await axios({
    method: 'POST',
    url: env.magento.GRAPHQL_URL,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${bearerToken}`,
      Store: getStoreName(),
    },
    data: {
      query: placeOrderMutation,
      variables: {
        cartId: payload.cartId,
        courseOption: payload.courseOption,
        quantity: payload.quantity,
        registrationId: payload.registrationId,
        sku: payload.sku,
        paying_by: payload.paying_by,
      },
    },
  })

  if (data.errors) {
    throw data.errors[0].message
  }

  if (data.data.wceiPlaceOrder) {
    return data.data.wceiPlaceOrder.order_id
  }

  return null
}
